import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { G_TABLE__inputs__base } from '../_base/G_TABLE__inputs__base';
import { HOOK_TABLE_LAYOUT__inputs__image_asset_list } from './HOOK_TABLE_LAYOUT__inputs__image_asset_list';

interface PROPS {
  fields: FIELD__list_image_asset[];
}

export function G_TABLE__inputs__image_asset_list({ fields }: PROPS) {
  const columns = HOOK_TABLE_LAYOUT__inputs__image_asset_list({ fields });

  return <G_TABLE__inputs__base title={'IMAGES LISTS'} fields={fields} columns={columns} />;
}
